import { requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { useUserState } from '../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import Close from '@mui/icons-material/Close';
import { AppBar, Box, Button, IconButton, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { useAccountsTable } from '../../hooks/useAccountsTable';
// FIXME need to review scope prop is not used correctly for example only message-members scope is used al the rest is ignored
export function showAccountsDialog(params) {
    showCustomDialog({
        fullScreen: true,
        content: (close, ariaLabelledBy, ariaDescribedBy) => (React.createElement(AccountsDialog, Object.assign({}, params, { close: close, ariaLabelledById: ariaLabelledBy, ariaDescribedById: ariaDescribedBy }))),
    });
}
export const AccountsDialog = (props) => {
    const userState = useUserState();
    const { t } = useContactManagementTranslation();
    const requireOrgRoleInStatusFilter = !requireAnySystemPermission(userState, 'all-organizations-admin') && props.scope === 'message-members';
    const { dataTableProps } = useAccountsTable({
        rowSelectionEnabled: true,
        requireOrgRoleInStatusFilter,
        staticStorageClientFilter: [{ column: 'systemStatus', op: '=', value: 'active' }],
        showAccountSystemRoleFilter: 'onlyAllFiltersPanel',
        showAllAccounts: props.showAllAccounts,
    });
    dataTableProps.localActions = [];
    dataTableProps.globalActions = [];
    return (React.createElement(LayoutRows2, { row1: React.createElement(AppBar, { sx: { position: 'relative' }, "data-test": 'app-bar' },
            React.createElement(Toolbar, null,
                React.createElement(IconButton, { edge: 'start', color: 'inherit', onClick: () => props.close(), "data-test": 'close-button', "aria-label": t('common.close') },
                    React.createElement(Close, null)),
                React.createElement(Typography, { id: props.ariaLabelledById, variant: 'h6', sx: { flexGrow: 1 } }, props.title),
                React.createElement(Button, { color: 'inherit', onClick: () => {
                        props.close(() => {
                            var _a;
                            props.onSelect((_a = dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : []);
                        });
                    }, "data-test": props.selectOperationName + '-button' }, props.selectOperationName))), row2: React.createElement(Box, { p: 2 },
            React.createElement(DataTable, Object.assign({}, dataTableProps, { "data-test": 'accounts-table' }))), fullHeightRow: 'row2', row2Scrollable: true }));
};
